import { render, staticRenderFns } from "./ChatFilterSelections.vue?vue&type=template&id=3ad3b1e2&"
import script from "./ChatFilterSelections.vue?vue&type=script&lang=js&"
export * from "./ChatFilterSelections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports